export default __webpack_public_path__ + "static/media/video.0775763b.mp4";